<template>
  <div class="container-fluid container-boxed">
    <div class="card">
      <div class="card-body">
        <h2>Program and Placement Details</h2>

        <no-results v-if="haveNoPlacements">
          You are not currently assigned to any placements.
        </no-results>
        <div v-for="program in groupedPlacements" :key="program.id">
          <h3>{{ program.name }}</h3>
          <active-placement-item v-for="placement in program.placements" :placement="placement" :key="placement.id"/>
        </div>
      </div>
    </div><!-- /.card -->

    <div class="decorative-divider"></div>

    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col">
            <h2 class="card-header-title mt-3">Assigned Graduates</h2>
          </div>
          <div class="col-auto">
            <button
              class="btn float-right"
              data-container="body"
              data-toggle="popover"
              data-placement="top"
              data-trigger="focus"
              data-content="A list of currently assigned graduates and previous graduates with an incomplete PDP.">
              <font-awesome :icon="['far', 'info-circle']"/>
            </button>
          </div>
        </div><!-- /.row -->
      </div>

      <ul class="list-data">
        <no-results v-if="haveNoGraduatePlacements">
          You have no assigned graduates.
        </no-results>
        <graduate-placement-item v-for="placement in graduate_placements" :placement="placement" :key="placement.graduate_placement_id"/>
      </ul>
    </div>

    <div class="decorative-divider"></div>

    <div class="card">
      <div class="card-header">
        <h2 class="card-header-title">Tasks</h2>
      </div>

      <ul class="list-data">
        <no-results v-if="haveNoTasks">
          There are no tasks available.
        </no-results>
        <task-list-item v-for="task in tasks" :task="task" :key="task.id"/>
        <li v-for="assessment in this.performance_assessments" :key="assessment.id" style="list-style: none">
          <router-link :to="{ name: 'graduates.assessments.single', params: { graduateId: assessment.graduate_id } }">
            <div class="row align-items-center">
              <div class="col-12 col-xl-4">
                <p class="strong">Overall Performance Assessment</p>
              </div>

              <div class="col-12 col-lg-7 col-xl-3">
                <p>{{ assessment.graduate_name }}</p>
              </div>

              <div class="col col-lg-3 text-lg-right">
                <p class="text-muted small">{{ getAssessmentDate(assessment) }}</p>
              </div>

              <div class="col-auto col-lg-2 text-right">
                <span class="status" :class="getAssessmentStatusClass(assessment.status)">{{ assessment.status }}</span>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </div><!-- /.card -->
  </div><!-- /.container-fluid -->
</template>

<script>
import { taskComputed, taskMethods, dashboardComputed, dashboardMethods } from 'vx/helpers'
import { map, groupBy } from 'lodash'
import TaskListItem from './DashboardTaskListItem'
import ActivePlacementItem from './DashboardActivePlacementItem'
import GraduatePlacementItem from './DashboardGraduatePlacementItem'
import moment from 'moment'

export default {
  components: {
    TaskListItem,
    ActivePlacementItem,
    GraduatePlacementItem
  },

  computed: {
    ...taskComputed,
    ...dashboardComputed,

    /**
     * Placements grouped by their program
     */
    groupedPlacements () {
      return map(groupBy(this.placements, 'program_id'), function (placements) {
        return {
          id: placements[0].program_id,
          name: placements[0].program.name,
          placements
        }
      })
    },

    haveNoGraduatePlacements () {
      return this.graduate_placements.length === 0
    },

    haveNoPlacements () {
      return this.groupedPlacements.length === 0
    },

    haveNoTasks () {
      return this.tasks.length === 0 && this.performance_assessments.length === 0
    }
  },

  async created () {
    await this.getActivePlacements()
    await this.getGraduatePlacements()
    await this.getTasks()
    await this.getPerformanceAssessments()
  },

  methods: {
    ...taskMethods,
    ...dashboardMethods,

    getAssessmentDate (assessment) {
      if (assessment.open_date && assessment.due_date) {
        const openDate = moment(assessment.open_date).startOf('day')
        const dueDate = moment(assessment.due_date).endOf('day')

        if (moment().isBetween(openDate, dueDate)) {
          return `Date: ${openDate.format('DD/MM/YYYY')}`
        } else if (moment().isAfter(dueDate)) {
          return `Date: ${dueDate.format('DD/MM/YYYY')}`
        }

        return `Date: ${openDate.format('DD/MM/YYYY')}`
      }

      return '-'
    },

    getAssessmentStatusClass (assessmentStatus) {
      if (assessmentStatus === 'Overdue') {
        return 'status-danger'
      }

      if (assessmentStatus === 'Upcoming') {
        return 'status-info'
      }

      return 'status-success'
    }
  }
}
</script>
